// extracted by mini-css-extract-plugin
module.exports = {"searchPageWrapper":"search_searchPageWrapper__8gTyZ","searchWrapper":"search_searchWrapper__XIEDc"};